<script setup lang="ts">
import {
  showVIPDialogue,
  showUserServiceDialogue,
  showLogoutDialogue,
  openVIP,
  openService,
} from "@/components/Dialogues/useData/useDialogues";

import { computed } from "vue";

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { ElMessage } from "element-plus";
const { userInfo, vipInfo, vipDisplay } = storeToRefs(publicStore());
</script>

<template>
  <div class="menu-base">
    <div class="menu-content">
      <div class="menu-item info">
        <div class="title">
          {{ userInfo.nickName }}
        </div>
        <div class="">ID: {{ userInfo.uid }}</div>
      </div>
      <div class="menu-item" @click="openVIP">
        <img class="vip-icon" src="@/assets/vip.png" alt="" srcset="" />
        <div>{{ vipDisplay }}</div>
      </div>
      <div class="menu-item" v-if="false">
        <el-icon :size="20"><Setting /></el-icon>
        <div>系统设置</div>
      </div>
      <div class="menu-item" @click="showUserServiceDialogue = true">
        <el-icon :size="20"><Connection /></el-icon>
        <div>关于我们</div>
      </div>
      <div class="menu-item" @click="openService">
        <el-icon :size="20"><Service /></el-icon>
        <div>联系客服</div>
      </div>
      <div class="menu-item" @click="showLogoutDialogue = true">
        <el-icon :size="20"><Close /></el-icon>
        <div>退出登录</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu-base {
  width: 100%;
  height: auto;
}

.menu-content {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;

  .menu-item {
    padding: 0 4px;
    border-radius: 4px;
    gap: 10px;
    display: flex;
    width: 100%;
    height: 48px;
    align-items: center;
    justify-content: start;
    font-size: 14px;
    &:hover {
      background-color: #dbeafe;
    }

    cursor: pointer;

    .vip-icon {
      width: 20px;
      height: 16px;
    }
  }

  .info {
    height: 56px;
    padding-left: 10px;
    flex-direction: column;
    align-items: start;
    &:hover {
      background-color: white;
      cursor: default;
    }
  }

  .title {
    font-size: 16px;
  }
}
</style>
